import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BlockDTO } from '../../../models/block';

@Component({
  selector: 'kw-block-card',
  template: `
    <div class="block-card" (click)="open.emit()">
      <div class="bc-stripe" [style.background]="block?.varietyColor || '#9aa5b1'"></div>
      <div class="bc-body">
        <div class="bc-head">
          <div>
            <h4>{{ block?.name }}</h4>
            <div class="bc-var">
              <span class="vd" [style.background]="block?.varietyColor || '#9aa5b1'"></span>
              {{ block?.varietyName }}<span *ngIf="block?.cropName"> &middot; {{ block?.cropName }}</span>
            </div>
          </div>
          <span class="tag" [class.org]="block?.isOrganic" [class.con]="!block?.isOrganic">
            {{ block?.isOrganic ? 'Organic' : 'Conv' }}
          </span>
        </div>
        <div class="bc-grid">
          <div class="bc-kv"><div class="n">{{ block?.gpsAcres | number:'1.1-1' }}<small> ac</small></div><div class="l">GPS acres</div></div>
          <div class="bc-kv"><div class="n">{{ block?.yearPlanted || '—' }}</div><div class="l">Year planted</div></div>
          <div class="bc-kv"><div class="n">{{ block?.plantCount ? (block.plantCount | number) : '—' }}</div><div class="l">Plants</div></div>
          <div class="bc-kv">
            <div class="n">
              <span class="mat" [style.color]="block?.isMature ? '#1b6f45' : '#e08700'">
                <span class="md" [style.background]="block?.isMature ? '#2fa66a' : '#e08700'"></span>
                {{ block?.isMature ? 'Mature' : 'Developing' }}
              </span>
            </div>
            <div class="l">Maturity</div>
          </div>
        </div>
        <div class="cf" *ngIf="customFields?.length" (click)="$event.stopPropagation()">
          <button type="button" class="cf-toggle" (click)="toggleCf($event)" [attr.aria-expanded]="expanded">
            <span class="caret">{{ expanded ? '&#9662;' : '&#9656;' }}</span>
            <span>Custom fields</span> <span class="cf-n">{{ customFields.length }}</span>
          </button>
          <div class="cf-list" *ngIf="expanded">
            <div class="cf-row" *ngFor="let f of customFields">
              <span class="cf-l">{{ f.label }}</span>
              <span class="cf-v">{{ f.value }}</span>
            </div>
          </div>
        </div>
        <div class="bc-foot">
          <span *ngIf="block?.fieldman">{{ block.fieldman }}</span>
          <span *ngIf="!block?.fieldman">&nbsp;</span>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .block-card { background: #fff; border: 1px solid #e4e9ef; border-radius: 12px;
      box-shadow: 0 1px 2px rgba(16,32,55,.04), 0 2px 8px rgba(16,32,55,.05);
      overflow: hidden; cursor: pointer; display: flex; transition: transform .12s, box-shadow .12s; }
    .block-card:hover { transform: translateY(-2px); box-shadow: 0 6px 24px rgba(16,32,55,.12); }
    .bc-stripe { width: 6px; flex: none; }
    .bc-body { padding: 14px 15px; flex: 1; min-width: 0; }
    .bc-head { display: flex; align-items: flex-start; justify-content: space-between; gap: 8px; }
    .bc-head h4 { margin: 0; font-size: 15px; font-weight: 700; }
    .bc-var { display: flex; align-items: center; gap: 7px; margin-top: 4px; font-size: 12.5px; color: #64748b; }
    .bc-var .vd { width: 9px; height: 9px; border-radius: 3px; }
    .tag { font-size: 10px; font-weight: 700; letter-spacing: .3px; text-transform: uppercase; padding: 2px 7px; border-radius: 5px; white-space: nowrap; }
    .tag.org { background: #e6f5ee; color: #1b6f45; } .tag.con { background: #eef1f4; color: #94a3b8; }
    .bc-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 9px 10px; margin-top: 13px; }
    .bc-kv .n { font-size: 14px; font-weight: 700; letter-spacing: -.2px; font-variant-numeric: tabular-nums; }
    .bc-kv .n small { font-size: 11px; color: #94a3b8; font-weight: 600; }
    .bc-kv .l { font-size: 10.5px; color: #64748b; font-weight: 600; margin-top: 1px; }
    .mat { display: inline-flex; align-items: center; gap: 5px; font-size: 11px; font-weight: 600; }
    .mat .md { width: 7px; height: 7px; border-radius: 50%; }
    .bc-foot { margin-top: 13px; padding-top: 11px; border-top: 1px solid #eef2f6; font-size: 12px; color: #64748b; }
    .cf { margin-top: 10px; padding-top: 4px; border-top: 1px solid #eef2f6; }
    .cf-toggle { border: none; background: none; width: 100%; padding: 9px 4px; cursor: pointer; font-size: 12px; font-weight: 600; color: #253d5b;
      display: flex; align-items: center; gap: 6px; border-radius: 6px; text-align: left; }
    .cf-toggle:hover { background: #f5f7f9; }
    .cf-toggle .caret { font-size: 10px; color: #94a3b8; }
    .cf-toggle .cf-n { font-size: 11px; color: #64748b; background: #eef2f6; border: 1px solid #e4e9ef; border-radius: 999px; padding: 0 7px; margin-left: auto; }
    .cf-list { margin-top: 10px; display: flex; flex-direction: column; gap: 7px; }
    .cf-row { display: flex; justify-content: space-between; gap: 12px; font-size: 12px; }
    .cf-row .cf-l { color: #64748b; font-weight: 600; flex: none; }
    .cf-row .cf-v { color: #17212e; text-align: right; word-break: break-word; }
  `]
})
export class BlockCardComponent {
  @Input() block: BlockDTO;
  @Input() customFields: { label: string; value: any }[] = [];
  @Output() open = new EventEmitter<void>();

  expanded = false;

  toggleCf(event: Event): void {
    event.stopPropagation();
    this.expanded = !this.expanded;
  }
}
